import React, { useState } from 'react'
import styled from 'styled-components'
import PageTitle from '../../_Components/Common/PageTitle/PageTitle'
import SceneWebMatchSignal from './SceneWebMatchSignal'

const SceneList = props => {
  const { sceneList, filters, setFilters, search, totalCount } = props

  const [playingId, setPlayingId] = useState(null)
  const [preview, setPreview] = useState(null)

  const publicYnOptions = [
    { name: '공개 전체', value: 'all' },
    { name: '공개 (Y)', value: 'Y' },
    { name: '비공개 (N)', value: 'N' },
    { name: '샘플 (S)', value: 'S' },
  ]

  const approveYnOptions = [
    { name: '심사 전체', value: 'all' },
    { name: '심사중 (P)', value: 'P' },
    { name: '승인 (Y)', value: 'Y' },
    { name: '거절 (N)', value: 'N' },
  ]

  const statusOptions = [
    { name: '생성 전체', value: 'all' },
    { name: '완료 (done)', value: 'done' },
    { name: '대기 (pending)', value: 'pending' },
    { name: '진행중 (processing)', value: 'processing' },
    { name: '실패 (failed)', value: 'failed' },
  ]

  const getDate = d => {
    if (!d) return ''
    const date = new Date(d)
    const kstDate = new Date(
      date.toLocaleString('en-US', { timeZone: 'Asia/Seoul' })
    )

    const formatted =
      `${kstDate.getFullYear()}-` +
      `${String(kstDate.getMonth() + 1).padStart(2, '0')}-` +
      `${String(kstDate.getDate()).padStart(2, '0')} ` +
      `${String(kstDate.getHours()).padStart(2, '0')}:` +
      `${String(kstDate.getMinutes()).padStart(2, '0')}:` +
      `${String(kstDate.getSeconds()).padStart(2, '0')}`

    return formatted
  }

  const approveBadge = approveYn => {
    if (approveYn === 'Y') return { text: '승인', color: '#28a745' }
    if (approveYn === 'N') return { text: '거절', color: '#dc3545' }
    return { text: '심사중', color: '#ffc107' }
  }

  const statusBadge = status => {
    if (status === 'done') return { text: 'done', color: '#28a745' }
    if (status === 'failed') return { text: 'failed', color: '#dc3545' }
    return { text: status, color: '#6c757d' }
  }

  return (
    <>
      <PageTitle
        mainTitle={'Scene Videos'}
        v1Link={''}
        navNames={['Scene']}
      />
      <SpaceResponsive height={10} />
      <section className="content">
        <div className="row">
          <section className="col-lg-12 connectedSortable">
            <div className="box box-info" style={{ padding: '0 10px' }}>
              <div className="box-body">
                <div style={{ marginTop: 10 }}>
                  <FilterWrapper>
                    <select
                      value={filters.publicYn}
                      onChange={e => setFilters({ publicYn: e.target.value })}
                    >
                      {publicYnOptions.map((o, i) => (
                        <option key={i} value={o.value}>
                          {o.name}
                        </option>
                      ))}
                    </select>
                    <select
                      value={filters.approveYn}
                      onChange={e => setFilters({ approveYn: e.target.value })}
                    >
                      {approveYnOptions.map((o, i) => (
                        <option key={i} value={o.value}>
                          {o.name}
                        </option>
                      ))}
                    </select>
                    <select
                      value={filters.status}
                      onChange={e => setFilters({ status: e.target.value })}
                    >
                      {statusOptions.map((o, i) => (
                        <option key={i} value={o.value}>
                          {o.name}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      placeholder="userId / 유저명 검색"
                      value={filters.q}
                      onChange={e => setFilters({ q: e.target.value })}
                      onKeyDown={e => {
                        if (e.key === 'Enter') search()
                      }}
                    />
                    <button onClick={() => search()}>검색</button>
                    {totalCount != null && (
                      <span id="total">총 {totalCount}건</span>
                    )}
                  </FilterWrapper>
                  <SpaceResponsive height={10} />
                  {sceneList.length === 0 && (
                    <EmptyBox>조건에 맞는 영상이 없습니다.</EmptyBox>
                  )}
                  <ImageWrapper>
                    {sceneList.map((p, i) => {
                      const isPlaying = playingId === p.seq
                      const displayVideoUrl = p.mosaic || p.videoUrl
                      const displayThumbnail = p.mosaicThumbnail || p.thumbnail
                      const approve = approveBadge(p.approveYn)
                      const status = statusBadge(p.status)
                      return (
                        <ImageBox key={i}>
                          <MediaArea
                            onClick={() =>
                              setPlayingId(isPlaying ? null : p.seq)
                            }
                          >
                            {isPlaying && displayVideoUrl ? (
                              <video
                                id="video"
                                src={displayVideoUrl}
                                controls
                                autoPlay
                                playsInline
                              />
                            ) : displayThumbnail ? (
                              <img id="thumbnail" src={displayThumbnail} alt="" />
                            ) : (
                              <div id="no-thumbnail">{p.status}</div>
                            )}
                            {!isPlaying && displayVideoUrl && (
                              <div id="play-overlay">
                                <div id="play-icon">▶</div>
                              </div>
                            )}
                            {p.publicYn === 'N' && (
                              <div id="private-tag">PRIVATE</div>
                            )}
                            {p.publicYn === 'S' && (
                              <div id="private-tag">SAMPLE</div>
                            )}
                            {p.imageUrl && (
                              <SourceImage
                                src={p.imageUrl}
                                alt=""
                                title="원본 업로드 사진 (클릭해서 확대)"
                                onClick={e => {
                                  e.stopPropagation()
                                  setPreview(p.imageUrl)
                                }}
                              />
                            )}
                          </MediaArea>
                          <InfoBox>
                            <div id="meta">
                              <div id="badges">
                                <Badge color={status.color}>{status.text}</Badge>
                                <Badge color={approve.color}>
                                  {approve.text}
                                </Badge>
                                {p.likeCount != null && (
                                  <Badge color="#e83e8c">
                                    ♥ {p.likeCount}
                                  </Badge>
                                )}
                              </div>
                              <div style={{ fontSize: '11px', color: '#888' }}>
                                seq: {p.seq}
                                {p.inputSource ? ` · ${p.inputSource}` : ''}
                              </div>
                              {p.motionName && (
                                <div style={{ fontWeight: 600 }}>
                                  {p.motionName}
                                </div>
                              )}
                              {(p.userName || p.userId) && (
                                <div>
                                  user: {p.userName || '-'} ({p.userId})
                                </div>
                              )}
                              {p.prompt && (
                                <PromptWrapper>
                                  <div id="prompt">{p.prompt}</div>
                                  <div id="tooltip">{p.prompt}</div>
                                </PromptWrapper>
                              )}
                              {p.regDate && <div>{getDate(p.regDate)}</div>}
                            </div>
                            <SceneWebMatchSignal scene={p} getDate={getDate} />
                          </InfoBox>
                        </ImageBox>
                      )
                    })}
                  </ImageWrapper>
                  <SpaceResponsive height={20} />
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      {preview && (
        <LightboxOverlay onClick={() => setPreview(null)}>
          <LightboxClose onClick={() => setPreview(null)}>×</LightboxClose>
          <LightboxImg src={preview} alt="" onClick={e => e.stopPropagation()} />
        </LightboxOverlay>
      )}
    </>
  )
}

export default SceneList

const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  cursor: zoom-out;
`

const LightboxImg = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  cursor: default;
`

const LightboxClose = styled.button`
  position: absolute;
  top: 20px;
  right: 24px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`

const SpaceResponsive = styled.div`
  height: ${props => props.height}px;
  flex-shrink: 0;
`

const EmptyBox = styled.div`
  width: 100%;
  text-align: center;
  padding: 40px 0;
  color: #888;
`

const FilterWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
  margin: 10px 0;
  flex-wrap: wrap;
  row-gap: 8px;

  select,
  input {
    height: 35px;
    padding: 0 10px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  input {
    width: 220px;
  }

  button {
    height: 35px;
    padding: 0 16px;
    box-sizing: border-box;
    color: #fff;
    background-color: #007bff;
    border-radius: 5px;
    border: none;

    &:hover {
      opacity: 0.8;
    }
  }

  #total {
    font-size: 13px;
    color: #555;
  }
`

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
`

const ImageBox = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Badge = styled.span`
  display: inline-block;
  padding: 1px 7px;
  border-radius: 9999px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background-color: ${props => props.color};
`

const SourceImage = styled.img`
  position: absolute;
  bottom: 8px;
  left: 8px;
  z-index: 3;
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  cursor: zoom-in;
  background-color: #fff;
`

const MediaArea = styled.div`
  width: 100%;
  max-width: 240px;
  aspect-ratio: 1 / 1;
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  background-color: #000;
  position: relative;
  cursor: pointer;

  #thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  #no-thumbnail {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #888;
    font-size: 13px;
  }

  #video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    background-color: #000;
  }

  #play-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.25);
    transition: background-color 0.2s;
  }

  &:hover #play-overlay {
    background-color: rgba(0, 0, 0, 0.45);
  }

  #play-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.9);
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    padding-left: 4px;
    box-sizing: border-box;
  }

  #private-tag {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    padding: 3px 8px;
    border-radius: 9999px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #fff;
    background: linear-gradient(135deg, #6b7280, #1f2937);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  }
`

const InfoBox = styled.div`
  width: 100%;
  max-width: 240px;
  margin: 0 auto;
  padding: 8px 4px;
  box-sizing: border-box;

  #meta {
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    font-size: 12px;
    color: #333;
    word-break: break-all;
  }

  #badges {
    display: flex;
    column-gap: 4px;
    margin-bottom: 2px;
  }

  #prompt {
    color: #555;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const PromptWrapper = styled.div`
  position: relative;
  cursor: pointer;

  #tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    width: max-content;
    max-width: 280px;
    padding: 8px 10px;
    background-color: rgba(0, 0, 0, 0.85);
    color: #fff;
    font-size: 12px;
    line-height: 1.4;
    border-radius: 6px;
    word-break: break-word;
    white-space: normal;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: opacity 0.15s ease;
    pointer-events: none;
  }

  #tooltip::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, 0.85) transparent;
  }

  &:hover #tooltip {
    visibility: visible;
    opacity: 1;
  }
`
